import { styled } from '@mui/system';
import { TextField as TextFieldMUI } from '@mui/material';

export const TextField = styled(TextFieldMUI)`
  .MuiFormLabel-root {
    font-size: 14px;
    top: -2px;
  }

  .MuiInputBase-root {
    font-size: 14px;
  }

  .MuiInputBase-root.Mui-error {
      background-color:rgb(126,10,15, 0.1);  
    }  
`;
